import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createSlots as _createSlots } from "vue";
const _hoisted_1 = { class: "col-span-2" };
const _hoisted_2 = { class: "flex flex-col gap-3" };
const _hoisted_3 = ["aria-label"];
const _hoisted_4 = {
    key: 1,
    class: "rounded-md border border-(--border-error-default) bg-(--surface-error-subtle) p-3 text-sm text-(--text-error-default)",
    role: "alert"
};
const _hoisted_5 = {
    key: 2,
    class: "text-sm text-(--text-text-grey-default) italic"
};
const _hoisted_6 = {
    key: 3,
    class: "social-profiles-list flex flex-col gap-2"
};
const _hoisted_7 = {
    key: 4,
    class: "mb-4"
};
import { Button, UrlInput } from "@eudonet/opal";
import { useSocialNetworkStore } from "@/shared/stores/useSocialNetworkStore";
export default /*@__PURE__*/ _defineComponent({
    __name: 'SocialProfileList',
    props: /*@__PURE__*/ _mergeModels({
        scope: {},
        loading: { type: Boolean },
        error: {},
        disabled: { type: Boolean }
    }, {
        "profiles": { required: true },
        "profilesModifiers": {},
    }),
    emits: /*@__PURE__*/ _mergeModels(["add", "delete"], ["update:profiles"]),
    setup(__props) {
        // A profile saved without a user label stores `null` (the FormModal shows the
        // network name only as a placeholder, so the catalog name never gets frozen
        // into the row). The display fallback therefore happens here: resolve the
        // generic network name from the session-cached catalog store.
        const networkStore = useSocialNetworkStore();
        void networkStore.load();
        function labelFor(profile) {
            return profile.label || networkStore.byId(profile.networkId)?.name;
        }
        // The stored `value` is a handle for prefix-based networks (LinkedIn, …) and a
        // full URL for prefix-less ones (Website). The complete profile URL is
        // therefore `{urlPrefix}{value}` — that resolved URL is what the row's copy
        // button copies and what the hover tooltip shows, so the user gets the real
        // link rather than the bare handle. The visible field keeps showing just the
        // handle (no prefix box) per the OP-5639 Figma alignment.
        function fullUrlFor(profile) {
            if (!profile.value.trim())
                return "";
            return `${profile.urlPrefix ?? ""}${profile.value}`;
        }
        // The stored value is a handle for prefix-based networks (e.g. LinkedIn) and a
        // full URL for prefix-less ones (e.g. Website) — so OPAL UrlInput's built-in
        // URL validation (which would reject a bare handle with a non-i18n English
        // message on blur) is intentionally disabled.
        const acceptAnyValue = () => undefined;
        // Two-way model so each row's UrlInput edits `profile.value` in place. The
        // parent owns the array (organisation `socialLinks`); mutating an element's
        // value flows back through the shared reference and surfaces in the next
        // `POST /organisations/{id}/save` round-trip (no separate REST endpoint).
        const profiles = _useModel(__props, "profiles");
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    (__props.loading)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            role: "status",
                            "aria-label": _ctx.$t('socialProfile.common.loading'),
                            class: "flex flex-col gap-2"
                        }, [
                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(2, (i) => {
                                return _createElementVNode("div", {
                                    key: i,
                                    class: "h-10 animate-pulse rounded-md bg-(--colors-border-base-soft)"
                                });
                            }), 64 /* STABLE_FRAGMENT */))
                        ], 8 /* PROPS */, _hoisted_3))
                        : (__props.error)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.$t(__props.error)), 1 /* TEXT */))
                            : (profiles.value.length === 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.$t("socialProfile.common.noProfiles")), 1 /* TEXT */))
                                : (_openBlock(), _createElementBlock("ul", _hoisted_6, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(profiles.value, (profile, index) => {
                                        return (_openBlock(), _createElementBlock("li", {
                                            key: profile.id || `draft-${index}`
                                        }, [
                                            _createVNode(_unref(UrlInput), {
                                                modelValue: profile.value,
                                                "onUpdate:modelValue": ($event) => ((profile.value) = $event),
                                                "icon-left": profile.iconClass,
                                                label: labelFor(profile),
                                                disabled: __props.disabled,
                                                "resolved-url": fullUrlFor(profile),
                                                validator: acceptAnyValue,
                                                "button-labels": {
                                                    label: _ctx.$t('socialProfile.common.copy'),
                                                    labelWhenCopied: _ctx.$t('socialProfile.common.copied'),
                                                },
                                                "full-width": ""
                                            }, _createSlots({ _: 2 /* DYNAMIC */ }, [
                                                (!__props.disabled)
                                                    ? {
                                                        name: "actions",
                                                        fn: _withCtx(() => [
                                                            _createVNode(_unref(Button), {
                                                                variant: "secondary",
                                                                size: "sm",
                                                                "icon-only": "",
                                                                "icon-left": "ri-delete-bin-line",
                                                                "aria-label": _ctx.$t('socialProfile.common.deleteAriaLabel', { value: profile.value }),
                                                                onClick: ($event) => (_ctx.$emit('delete', profile))
                                                            }, null, 8 /* PROPS */, ["aria-label", "onClick"])
                                                        ]),
                                                        key: "0"
                                                    }
                                                    : undefined
                                            ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["modelValue", "onUpdate:modelValue", "icon-left", "label", "disabled", "resolved-url", "button-labels"])
                                        ]));
                                    }), 128 /* KEYED_FRAGMENT */))
                                ])),
                    (!__props.disabled)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            _createVNode(_unref(Button), {
                                variant: "secondary",
                                size: "sm",
                                label: _ctx.$t('socialProfile.common.addButton'),
                                "icon-left": "ri-add-line",
                                onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('add')))
                            }, null, 8 /* PROPS */, ["label"])
                        ]))
                        : _createCommentVNode("v-if", true)
                ])
            ]));
        };
    }
});
